var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 0.933182V5.09504C17.9996 5.61142 17.6409 6.02822 17.1965 6.02822C16.7521 6.02822 16.3935 5.61143 16.3935 5.09504V3.10742L11.1203 9.23496C10.8178 9.58644 10.2851 9.58644 9.98259 9.23496L6.74921 5.47757L1.37179 11.7262C1.21383 11.9097 1.0077 12 0.804368 12C0.598234 12 0.3921 11.9097 0.236943 11.7262C-0.0789811 11.3623 -0.0789811 10.7713 0.236943 10.4075L6.18221 3.49623C6.48208 3.14778 7.01741 3.14778 7.31706 3.49623L10.5506 7.25667L15.1894 1.86636H13.6153C13.1737 1.86636 12.8123 1.44957 12.8123 0.933182C12.8123 0.416791 13.1735 0 13.6153 0H17.1969C17.6413 0 18 0.416791 18 0.933182H17.9996Z",
    fill: "#58F2F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.002c324a427a5b952090cbbec932c9b6.svg";
export { ForwardRef as ReactComponent };